var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"margin-top":"10px"}},_vm._l((_vm._value),function(selected,index){return _c('el-tag',{key:index + '_selected',staticClass:"selected-item",attrs:{"closable":"","size":"mini"},on:{"close":function($event){return _vm.remove(index)}}},[_vm._v(" "+_vm._s(selected.nickname)+" ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }